import React, { useEffect, useContext } from "react";
import { AppContext } from "./AppContext";
import { INBOUND, OUTBOUND } from "../utils/constants";
import { updateOutbound, updateInbound } from "../actions/appActions";
import { defaultPlansState, plansContextReducer } from "../reducers/plansContextReducer";
import { useReducerWithLogging } from "../utils/useReducerWithLogging";

const PlansContext = React.createContext();
const usePlansContext = () => useContext(PlansContext);

const PlansContextProvider = props => {
    const {
        state: { inbound, outbound },
        dispatch: appDispatch,
    } = useContext(AppContext);

    const [state, dispatch] = useReducerWithLogging(plansContextReducer, defaultPlansState);
    const { plans, tabIndex } = state;

    useEffect(() => {
        if (plans) {
            //default inbound/outbound plan would be the first plan in the plan list
            let defaultOutbound = {
                planHandle: null,
                allocation: null,
                coupons: [],
            };
            let defaultInbound = {
                planHandle: null,
                allocation: null,
                coupons: [],
            };
            if (plans[OUTBOUND][0]) {
                defaultOutbound.planHandle = plans[OUTBOUND][0].planHandle;
                defaultOutbound.allocation = plans[OUTBOUND][0].includedEmails;
            }
            if (plans[INBOUND][0]) {
                defaultInbound.planHandle = plans[INBOUND][0].planHandle;
                defaultInbound.allocation = 5;
            }
            switch (tabIndex) {
                case "0": // inbound only tab
                    if (!inbound.planHandle) {
                        //recommended outbound plan
                        appDispatch(updateInbound({ ...defaultInbound }));
                    }
                    appDispatch(updateOutbound({ planHandle: null }));
                    break;
                case "1": // outbound only tab
                    if (!outbound.planHandle) {
                        appDispatch(updateOutbound({ ...defaultOutbound })); //recommended outbound plan
                    }
                    appDispatch(updateInbound({ planHandle: null }));
                    break;
                default:
                    // inbound and outbound tab
                    appDispatch(updateInbound({ ...defaultInbound }));
                    appDispatch(updateOutbound({ ...defaultOutbound }));
            }
        }
    }, [plans, tabIndex]);

    return (
        <PlansContext.Provider value={{ state, dispatch }}>{props.children}</PlansContext.Provider>
    );
};

const PlansContextConsumer = PlansContext.Consumer;

export { PlansContext, PlansContextProvider, PlansContextConsumer, usePlansContext };
